export const translations = {
  sq: {
    // Navigation
    nav: {
      home: "Kryefaqja",
      services: "Shërbimet",
      salami: "Sallameria",
      sustainability: "Qëndrueshmëria",
      about: "Rreth Nesh",
      gallery: "Galeria",
      blog: "Lajme",
      faq: "FAQ",
      contact: "Kontakt",
      admin: "Admin"
    },
    // Hero Section
    hero: {
      overline: "FURNIZUES I BESUAR B2B",
      title: "Zinxhir i plotë. Cilësi e garantuar.",
      subtitle: "Nga importi i blegtorisë deri te produkti final.",
      cta: "Bashkohu me Ne",
      learnMore: "Mëso Më Shumë"
    },
    // Services Page
    services: {
      title: "Shërbimet Tona",
      subtitle: "Ofrojmë zgjidhje të integruara për industrinë e mishit",
      import: {
        title: "Importi i Blegtorisë",
        desc: "Importojmë derra të gjallë nga furnizues të certifikuar evropianë. Kontroll i plotë nga origjina deri te arritja.",
        features: [
          "Furnizues të certifikuar nga BE",
          "Gjurmueshmëri e plotë",
          "Transport i specializuar",
          "Kontroll veterinar"
        ]
      },
      carcass: {
        title: "Furnizimi me Karkasa",
        desc: "Karkasë e plotë, pa shpatulla, ose sipas kërkesës tuaj. Fleksibilitet maksimal për nevojat tuaja.",
        features: [
          "Karkasë e plotë",
          "Gjysmë karkasa",
          "Pa shpatulla",
          "Formate të personalizuara"
        ]
      },
      processing: {
        title: "Përpunimi i Mishit",
        desc: "Sektori ynë i përpunimit ofron prerje profesionale, paketim modern dhe zgjidhje të personalizuara.",
        features: [
          "Prerje sipas specifikimeve",
          "Paketim vakum",
          "Atmosferë e modifikuar",
          "Etiketim i personalizuar"
        ]
      },
      slaughterhouse: {
        title: "Thertorja",
        desc: "Operojmë sipas standardeve më të larta të higjienës dhe sigurisë ushqimore.",
        features: [
          "Standarde HACCP",
          "Kontroll i temperaturës",
          "Higjiena supreme",
          "Certifikime ndërkombëtare"
        ]
      },
      transport: {
        title: "Transporti i Kafshëve të Gjalla",
        desc: "Ofrojmë shërbime të specializuara transporti për kafshë të gjalla, me standarde të larta sigurie dhe mirëqenie.",
        features: [
          "Transport për të tretë brenda dhe jashtë vendit",
          "Import i kafshëve të gjalla në Shqipëri",
          "Transport brenda shtetit",
          "Mjete të specializuara transporti"
        ]
      }
    },
    // Salami Page
    salami: {
      title: "Sallameria Tamari",
      subtitle: "Produktet tona artizanale të sallamit dhe mishit të përpunuar",
      intro: "Me traditë dhe ekspertizë, prodhojmë sallam dhe produkte mishi të cilësisë së lartë për tregun B2B.",
      products: {
        title: "Produktet e Sallamerisë",
        items: [
          { 
            name: "Sallam Llukanik i Shkurtër", 
            ingredients: "Mish Derri, arome, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, piper, kripe, qepe, spec i kuq.",
            origin: "Importi",
            nutrition: { energy: "1110,29 / 264,03 kJ/kcal", fat: "21,15g", saturated: "8,62g", carbs: "2,29g", sugar: "0g", protein: "16,13g", fiber: "0g", salt: "2,76g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e konsumueshme.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/vyujta0c_021A2199.JPG"
          },
          { 
            name: "Sallam Llukanik i Gjatë", 
            ingredients: "Mish Derri, arome, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, piper, kripe, qepe, spec i kuq.",
            origin: "Importi",
            nutrition: { energy: "1110,29 / 264,03 kJ/kcal", fat: "21,15g", saturated: "8,62g", carbs: "2,29g", sugar: "0g", protein: "16,13g", fiber: "0g", salt: "2,76g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e konsumueshme. Disponohet edhe me presh.",
            images: [
              "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/fo73h6ee_021A2189.JPG",
              "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/6rhrm3o7_021A2122.JPG"
            ]
          },
          { 
            name: "Sallam Llukanik Pikant", 
            ingredients: "Mish Derri, aromë, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, rigon, piper, kripe, spec i kuq djegës.",
            origin: "Importi",
            nutrition: { energy: "1077,86 / 256,53 kJ/kcal", fat: "21,77g", saturated: "5,76g", carbs: "3,15g", sugar: "0g", protein: "13,06g", fiber: "2,21g", salt: "2,85g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e konsumueshme.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/g5frx3lh_021A2129.JPG"
          },
          { 
            name: "Sallam Turist", 
            ingredients: "Mish Derri, arome, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, piper, hudher, kripe.",
            origin: "Importi",
            nutrition: { energy: "1446,01 / 345,11 kJ/kcal", fat: "27,07g", saturated: "10,47g", carbs: "7,37g", sugar: "0g", protein: "18,00g", fiber: "0g", salt: "3,7g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e pa konsumueshme.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/ox33yr14_021A2217.JPG"
          },
          { 
            name: "Sallam Popullor", 
            ingredients: "Mish Derri, arome, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, piper, kripë.",
            origin: "Importi",
            nutrition: { energy: "805,23 / 192,18 kJ/kcal", fat: "11,66g", saturated: "4,33g", carbs: "7,12g", sugar: "0g", protein: "14,69g", fiber: "0g", salt: "3,56g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e konsumueshme.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/tb8ilwbb_021A2203.JPG"
          },
          { 
            name: "Sallam Tradita", 
            ingredients: "Mish Derri, aromë, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, piper, hudher, kripe.",
            origin: "Importi",
            nutrition: { energy: "948,99 / 226,49 kJ/kcal", fat: "14,93g", saturated: "5,80g", carbs: "7,09g", sugar: "0g", protein: "15,94g", fiber: "0g", salt: "3,69g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e konsumueshme.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/uqdmygwq_021A2138.JPG"
          },
          { 
            name: "Sallamino", 
            ingredients: "Mish Derri, arome, glutamate monosodium E-621, aromë natyrale (aromë druri), stabilizues E-450, antioksidues E-301, konservues E-250, piper, kripe, hudher.",
            origin: "Importi",
            nutrition: { energy: "1077,46 / 257,15 kJ/kcal", fat: "20,95g", saturated: "7,77g", carbs: "3,15g", sugar: "0g", protein: "14,00g", fiber: "0g", salt: "3,18g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e konsumueshme.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/1yfsfchb_021A2147.JPG"
          },
          { 
            name: "Milanez Tamari", 
            ingredients: "Mish derri, aromë glutamate monosodium E-621, Stabilizues E-450, Antioksidues E-301, konservues E-250, piper, kripë.",
            origin: "Importi",
            nutrition: { energy: "1205,28 / 290,36 kJ/kcal", fat: "23g", saturated: "16,1g", carbs: "2,16g", sugar: "0g", protein: "18,68g", fiber: "0g", salt: "3,11g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e pakonsumueshme."
          },
          { 
            name: "Parizier i Madh", 
            ingredients: "Mish Derri, arome, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, piper, kripë.",
            origin: "Importi",
            nutrition: { energy: "805,23 / 192,18 kJ/kcal", fat: "11,66g", saturated: "4,33g", carbs: "7,12g", sugar: "0g", protein: "14,69g", fiber: "0g", salt: "3,56g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e pa konsumueshme."
          },
          { 
            name: "Parizier i Mesëm", 
            ingredients: "Mish Derri, arome, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, piper, kripë.",
            origin: "Importi",
            nutrition: { energy: "805,23 / 192,18 kJ/kcal", fat: "11,66g", saturated: "4,33g", carbs: "7,12g", sugar: "0g", protein: "14,69g", fiber: "0g", salt: "3,56g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e pa konsumueshme."
          },
          { 
            name: "Parizier i Vogël", 
            ingredients: "Mish Derri, arome, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, piper, kripë.",
            origin: "Importi",
            nutrition: { energy: "805,23 / 192,18 kJ/kcal", fat: "11,66g", saturated: "4,33g", carbs: "7,12g", sugar: "0g", protein: "14,69g", fiber: "0g", salt: "3,56g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e pa konsumueshme."
          },
          { 
            name: "Qofte e Madhe", 
            ingredients: "Mish Derri, proteine bimore (SOJE), aromë, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, galete, rigon, piper, qepë, spec i kuq, kripe.",
            origin: "Importi",
            nutrition: { energy: "1085,42 / 259,05 kJ/kcal", fat: "18,85g", saturated: "7,21g", carbs: "7,60g", sugar: "0g", protein: "14,75g", fiber: "0g", salt: "3,15g" },
            storage: "Të ruhet në temp. -18°C",
            notes: "Mos e ringrint pas shkrirjes. Ideale për pjekje në zgarë, por edhe në tigan."
          },
          { 
            name: "Qofte e Vogël", 
            ingredients: "Mish Derri, proteine bimore (SOJE), aromë, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, galete, rigon, piper, qepë, spec i kuq, kripe.",
            origin: "Importi",
            nutrition: { energy: "1085,42 / 259,05 kJ/kcal", fat: "18,85g", saturated: "7,21g", carbs: "7,60g", sugar: "0g", protein: "14,75g", fiber: "0g", salt: "3,15g" },
            storage: "Të ruhet në temp. -18°C",
            notes: "Mos e ringrint pas shkrirjes. Ideale për pjekje në zgarë, por edhe në tigan."
          },
          { 
            name: "Hamburger", 
            ingredients: "Mish Derri, proteine bimore (SOJE), arome, glutamate monosodium E-621, stabilizues E-450, antioksidues E-301, konservues E-250, galet, rigon, piper, qepe, spec i kuq, kripe.",
            origin: "Importi",
            nutrition: { energy: "1132,77 / 270,35 kJ/kcal", fat: "18,69g", saturated: "7,95g", carbs: "10,44g", sugar: "0g", protein: "15,69g", fiber: "1,19g", salt: "2,75g" },
            storage: "Të ruhet në temp. -18°C",
            notes: "Mos e ringrint pas shkrirjes. Ideale për pjekje në zgarë, por edhe në tigan."
          },
          { 
            name: "Salçiçe të Tymosura", 
            ingredients: "Mish Derri, Proteine Bimore (SOJE), arome, glutamate monosodium E-621, arome natyrale (arome druri), stabilizues E-450, antioksidues E-301, konservues E-250, piper, kripe.",
            origin: "Importi",
            nutrition: { energy: "948,99 / 226,49 kJ/kcal", fat: "14,93g", saturated: "5,8g", carbs: "7,09g", sugar: "0g", protein: "15,94g", fiber: "0g", salt: "3,69g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme e konsumueshme.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/4azidk8b_021A2202.JPG"
          },
          { 
            name: "Salçiçe Speciale", 
            ingredients: "Mish Derri, PROTEINE BIMORE (SOJE), Aromë glutamate monosodium E-621, Stabilizues E-451, Antioksidues E-300, konservues E-202, Piper, Kripe.",
            origin: "Importi",
            nutrition: { energy: "659,47 / 156,64 kJ/kcal", fat: "5g", saturated: "1,81g", carbs: "2,64g", sugar: "0,11g", protein: "25,27g", fiber: "0g", salt: "3,25g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: "Veshja e jashtme material kolagjen, i konsumushëm.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/x2khrju9_021A2162.JPG"
          },
          { 
            name: "Mish i Tymosur", 
            ingredients: "Mish Derri, Aroma natyrale (arome druri), Kripë, Konservues E-202.",
            origin: "Importi",
            nutrition: { energy: "524,67 / 124,99 kJ/kcal", fat: "5,23g", saturated: "1,85g", carbs: "1,46g", sugar: "0g", protein: "18,02g", fiber: "0g", salt: "4,85g" },
            storage: "Të ruhet në temp. 1-5°C",
            notes: ""
          }
        ]
      },
      quality: {
        title: "Cilësia e Garantuar",
        points: [
          "Mish 100% i freskët nga thertorja jonë",
          "Erëza natyrale të zgjedhura",
          "Proces tradicional i kombinuar me teknologji moderne",
          "Kontroll cilësie në çdo fazë"
        ]
      },
      cta: "Kërkoni Ofertë për Sallamerinë"
    },
    // About Page
    about: {
      title: "Rreth Tamari",
      subtitle: "Një zinxhir i plotë. Një përgjegjësi e ndarë në çdo hap.",
      history: {
        title: "Origjina",
        content: "Tamari lindi nga bindja se mishi nuk është vetëm produkt — është rezultat i një procesi që kërkon kujdes, disiplinë dhe respekt. Që nga dita e parë, ne kemi zgjedhur të mos ndajmë kompromise me cilësinë. Ndërtuam një strukturë ku çdo hallkë — nga importi i blegtorisë së gjallë, te thertorja, te paketimi — i përgjigjet të njëjtit parim: punë e bërë mirë."
      },
      philosophy: {
        title: "Filozofia jonë",
        content: "Besojmë në harmoninë midis traditës dhe teknologjisë. Mes përvojës që fitohet me kohë dhe saktësisë që e jep makineria moderne. Çdo orë pune në Tamari kalon nën të njëjtin ritëm: kontroll, qartësi, përgjegjësi."
      },
      mission: {
        title: "Misioni",
        content: "Të jemi furnizuesi i besuar i industrisë së mishit në Shqipëri — duke garantuar gjurmueshmëri të plotë, standarde europiane dhe një partneritet që ndërtohet me kohë, jo me premtime. Klientët B2B që na zgjedhin, na zgjedhin për arsye të thjeshta: konsistenca, seriozitetin dhe faktin që çdo karkasë, çdo prerje, çdo paketë mban të njëjtin emër — emrin tonë."
      },
      values: {
        title: "Vlerat Tona",
        items: [
          { title: "Cilësia", desc: "Pa ekuivalente. Çdo produkt që del nga linja jonë ka kaluar të njëjtin kontroll si i pari." },
          { title: "Besueshmëria", desc: "Marrëdhëniet tona maten në vite, jo në porosi." },
          { title: "Transparenca", desc: "Gjurmueshmëri e plotë nga blegtoria deri tek banaku i klientit." },
          { title: "Inovacioni", desc: "Teknologji moderne në shërbim të procesit, jo në vend të tij." }
        ]
      },
      numbers: {
        title: "Tamari në Numra",
        items: [
          { number: "15+", label: "Vite Përvojë" },
          { number: "500+", label: "Partnerë B2B" },
          { number: "100%", label: "Gjurmueshmëri" },
          { number: "24/7", label: "Mbështetje" }
        ]
      }
    },
    // Gallery Page
    gallery: {
      title: "Galeria",
      subtitle: "Shiko objektet dhe proceset tona",
      categories: {
        all: "Të Gjitha",
        slaughterhouse: "Thertorja",
        salami: "Sallameria",
        stables: "Stalla",
        transport: "Transporti"
      },
      team: {
        title: "Ekipi Ynë",
        subtitle: "Njihuni me ekipin profesional të Tamari"
      }
    },
    // Blog Page
    blog: {
      title: "Lajme & Artikuj",
      subtitle: "Njoftime dhe informacione nga Tamari",
      readMore: "Lexo më shumë",
      categories: {
        all: "Të Gjitha",
        news: "Lajme",
        industry: "Industria",
        tips: "Këshilla"
      },
      empty: "Nuk ka artikuj për momentin."
    },
    // FAQ Page
    faq: {
      title: "Pyetje të Shpeshta",
      subtitle: "Përgjigje për pyetjet më të zakonshme nga klientët tanë B2B",
      categories: {
        all: "Të Gjitha",
        general: "Të Përgjithshme",
        ordering: "Porositë",
        delivery: "Dërgesa",
        quality: "Cilësia"
      },
      contact: "Nuk gjete përgjigjen? Na kontakto direkt."
    },
    // Contact Page
    contact: {
      title: "Kontaktoni",
      subtitle: "Jemi të gatshëm të diskutojmë nevojat tuaja specifike",
      form: {
        name: "Emri i Plotë",
        company: "Kompania",
        businessType: "Lloji i Biznesit",
        businessTypes: {
          wholesale: "Shumicë",
          retail: "Pakicë / Dyqan",
          distribution: "Distributor",
          restaurant: "Restorant / HoReCa",
          other: "Tjetër"
        },
        email: "Email",
        phone: "Telefon",
        message: "Mesazhi",
        submit: "Dërgo Kërkesën",
        success: "Mesazhi u dërgua me sukses!",
        error: "Ndodhi një gabim. Ju lutem provoni përsëri."
      },
      info: {
        email: "Email",
        slaughterhouse: "Thertorja",
        slaughterhouseAddress: "Rruga Pularia, Dushnik, Berat, Shqipëri",
        slaughterhouseHours: "E Hënë - E Shtunë: 07:00 - 16:00",
        salami: "Sallameria",
        salamiAddress: "Rruga Mbroshkat Nr27, Lapardha, Berat, Shqipëri",
        salamiHours: "E Hënë - E Shtunë: 07:00 - 15:00",
        hours: "Orari"
      }
    },
    // Quality Section
    quality: {
      title: "Cilësia & Siguria",
      subtitle: "Gjurmueshmëri e plotë nga origjina deri te klienti final",
      features: {
        traceability: "Gjurmueshmëri 100%",
        hygiene: "Higjiena Supreme",
        consistency: "Konsistencë e Garantuar",
        certification: "Certifikime Ndërkombëtare"
      }
    },
    // Sustainability Section
    sustainability: {
      overline: "QËNDRUESHMËRI & STANDARDE",
      title: "Prodhim i pastër. Pa kompromis.",
      subtitle: "Çdo hap i zinxhirit tonë respekton mjedisin dhe standardet më të larta europiane.",
      features: [
        {
          title: "Trajtim i Mbetjeve",
          desc: "Incinerator modern për asgjësimin e sigurt të mbetjeve të pakonsumueshme."
        },
        {
          title: "Ujëra të Pastra",
          desc: "Impiant i dedikuar për trajtimin e ujërave të përdorura në thertore."
        },
        {
          title: "Riciklim Organik",
          desc: "Mbetjet organike kthehen në burim për bujqësinë lokale."
        },
        {
          title: "Mirëqenie Kafshësh",
          desc: "Rritje në kushte optimale sipas standardeve të BE-së."
        }
      ],
      closing: "Standarde europiane. Përgjegjësi lokale.",
      euOverline: "STANDARDE BE",
      euDesc: "Çdo aspekt i operacioneve tona është në përputhje me rregulloret dhe standardet e Bashkimit Europian për sigurinë ushqimore, mbrojtje mjedisore dhe mirëqenie kafshësh.",
      futureTitle: "Përgjegjësi për të ardhmen",
      futureDesc: "Ne besojmë se prodhimi cilësor dhe përgjegjësia mjedisore shkojnë së bashku. Kjo është mënyra jonë e të bërit biznes."
    },
    // Footer
    footer: {
      tagline: "Furnizues i besuar për industrinë e mishit në Shqipëri",
      rights: "Të gjitha të drejtat e rezervuara",
      links: {
        services: "Shërbimet",
        about: "Rreth Nesh",
        contact: "Kontakt",
        privacy: "Privatësia"
      }
    },
    // Admin
    admin: {
      title: "Paneli i Administrimit",
      dashboard: "Dashboard",
      contacts: "Kontaktet",
      blog: "Blog",
      gallery: "Galeria",
      faq: "FAQ",
      products: "Produktet",
      stats: {
        totalContacts: "Kontakte Totale",
        newContacts: "Kontakte të Reja",
        blogPosts: "Artikuj Blog",
        galleryItems: "Foto Galerie"
      },
      actions: {
        add: "Shto",
        edit: "Ndrysho",
        delete: "Fshi",
        save: "Ruaj",
        cancel: "Anulo",
        view: "Shiko"
      },
      status: {
        new: "I Ri",
        contacted: "Kontaktuar",
        closed: "Mbyllur"
      }
    },
    // Common
    common: {
      loading: "Duke ngarkuar...",
      error: "Ndodhi një gabim",
      backToHome: "Kthehu në Kryefaqje",
      seeAll: "Shiko të gjitha"
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      salami: "Deli Meats",
      sustainability: "Sustainability",
      about: "About Us",
      gallery: "Gallery",
      blog: "News",
      faq: "FAQ",
      contact: "Contact",
      admin: "Admin"
    },
    // Hero Section
    hero: {
      overline: "TRUSTED B2B SUPPLIER",
      title: "Complete Chain. Guaranteed Quality.",
      subtitle: "From livestock import to final product.",
      cta: "Partner With Us",
      learnMore: "Learn More"
    },
    // Services Page
    services: {
      title: "Our Services",
      subtitle: "We offer integrated solutions for the meat industry",
      import: {
        title: "Livestock Import",
        desc: "We import live pigs from certified European suppliers. Full control from origin to arrival.",
        features: [
          "EU certified suppliers",
          "Full traceability",
          "Specialized transport",
          "Veterinary control"
        ]
      },
      carcass: {
        title: "Carcass Supply",
        desc: "Full carcass, without shoulders, or as per your request. Maximum flexibility for your needs.",
        features: [
          "Full carcass",
          "Half carcass",
          "Without shoulders",
          "Custom formats"
        ]
      },
      processing: {
        title: "Meat Processing",
        desc: "Our processing sector offers professional cutting, modern packaging and customized solutions.",
        features: [
          "Custom cuts",
          "Vacuum packaging",
          "Modified atmosphere",
          "Custom labeling"
        ]
      },
      slaughterhouse: {
        title: "Slaughterhouse",
        desc: "We operate according to the highest hygiene and food safety standards.",
        features: [
          "HACCP standards",
          "Temperature control",
          "Supreme hygiene",
          "International certifications"
        ]
      },
      transport: {
        title: "Live Animal Transport",
        desc: "We offer specialized transport services for live animals, with high safety and welfare standards.",
        features: [
          "Transport for third parties domestically and internationally",
          "Import of live animals to Albania",
          "Domestic transport within the country",
          "Specialized transport vehicles"
        ]
      }
    },
    // Salami Page
    salami: {
      title: "Tamari Deli Meats",
      subtitle: "Our artisanal salami and processed meat products",
      intro: "With tradition and expertise, we produce high-quality salami and meat products for the B2B market.",
      products: {
        title: "Deli Products",
        items: [
          { 
            name: "Short Llukanik Salami", 
            ingredients: "Pork meat, flavors, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, pepper, salt, onion, red pepper.",
            origin: "Import",
            nutrition: { energy: "1110.29 / 264.03 kJ/kcal", fat: "21.15g", saturated: "8.62g", carbs: "2.29g", sugar: "0g", protein: "16.13g", fiber: "0g", salt: "2.76g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is edible.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/vyujta0c_021A2199.JPG"
          },
          { 
            name: "Long Llukanik Salami", 
            ingredients: "Pork meat, flavors, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, pepper, salt, onion, red pepper.",
            origin: "Import",
            nutrition: { energy: "1110.29 / 264.03 kJ/kcal", fat: "21.15g", saturated: "8.62g", carbs: "2.29g", sugar: "0g", protein: "16.13g", fiber: "0g", salt: "2.76g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is edible. Also available with leek.",
            images: [
              "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/fo73h6ee_021A2189.JPG",
              "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/6rhrm3o7_021A2122.JPG"
            ]
          },
          { 
            name: "Spicy Llukanik Salami", 
            ingredients: "Pork meat, flavor, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, oregano, pepper, salt, hot red pepper.",
            origin: "Import",
            nutrition: { energy: "1077.86 / 256.53 kJ/kcal", fat: "21.77g", saturated: "5.76g", carbs: "3.15g", sugar: "0g", protein: "13.06g", fiber: "2.21g", salt: "2.85g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is edible.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/g5frx3lh_021A2129.JPG"
          },
          { 
            name: "Tourist Salami", 
            ingredients: "Pork meat, flavors, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, pepper, garlic, salt.",
            origin: "Import",
            nutrition: { energy: "1446.01 / 345.11 kJ/kcal", fat: "27.07g", saturated: "10.47g", carbs: "7.37g", sugar: "0g", protein: "18.00g", fiber: "0g", salt: "3.7g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is not edible.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/ox33yr14_021A2217.JPG"
          },
          { 
            name: "Popular Salami", 
            ingredients: "Pork meat, flavors, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, pepper, salt.",
            origin: "Import",
            nutrition: { energy: "805.23 / 192.18 kJ/kcal", fat: "11.66g", saturated: "4.33g", carbs: "7.12g", sugar: "0g", protein: "14.69g", fiber: "0g", salt: "3.56g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is edible.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/tb8ilwbb_021A2203.JPG"
          },
          { 
            name: "Traditional Salami", 
            ingredients: "Pork meat, flavor, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, pepper, garlic, salt.",
            origin: "Import",
            nutrition: { energy: "948.99 / 226.49 kJ/kcal", fat: "14.93g", saturated: "5.80g", carbs: "7.09g", sugar: "0g", protein: "15.94g", fiber: "0g", salt: "3.69g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is edible.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/uqdmygwq_021A2138.JPG"
          },
          { 
            name: "Sallamino", 
            ingredients: "Pork meat, flavors, monosodium glutamate E-621, natural flavor (wood smoke), stabilizer E-450, antioxidant E-301, preservative E-250, pepper, salt, garlic.",
            origin: "Import",
            nutrition: { energy: "1077.46 / 257.15 kJ/kcal", fat: "20.95g", saturated: "7.77g", carbs: "3.15g", sugar: "0g", protein: "14.00g", fiber: "0g", salt: "3.18g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is edible.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/1yfsfchb_021A2147.JPG"
          },
          { 
            name: "Milano Tamari", 
            ingredients: "Pork meat, flavor monosodium glutamate E-621, Stabilizer E-450, Antioxidant E-301, preservative E-250, pepper, salt.",
            origin: "Import",
            nutrition: { energy: "1205.28 / 290.36 kJ/kcal", fat: "23g", saturated: "16.1g", carbs: "2.16g", sugar: "0g", protein: "18.68g", fiber: "0g", salt: "3.11g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is not edible."
          },
          { 
            name: "Large Parizier", 
            ingredients: "Pork meat, flavors, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, pepper, salt.",
            origin: "Import",
            nutrition: { energy: "805.23 / 192.18 kJ/kcal", fat: "11.66g", saturated: "4.33g", carbs: "7.12g", sugar: "0g", protein: "14.69g", fiber: "0g", salt: "3.56g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is not edible."
          },
          { 
            name: "Medium Parizier", 
            ingredients: "Pork meat, flavors, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, pepper, salt.",
            origin: "Import",
            nutrition: { energy: "805.23 / 192.18 kJ/kcal", fat: "11.66g", saturated: "4.33g", carbs: "7.12g", sugar: "0g", protein: "14.69g", fiber: "0g", salt: "3.56g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is not edible."
          },
          { 
            name: "Small Parizier", 
            ingredients: "Pork meat, flavors, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, pepper, salt.",
            origin: "Import",
            nutrition: { energy: "805.23 / 192.18 kJ/kcal", fat: "11.66g", saturated: "4.33g", carbs: "7.12g", sugar: "0g", protein: "14.69g", fiber: "0g", salt: "3.56g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is not edible."
          },
          { 
            name: "Large Kofte", 
            ingredients: "Pork meat, vegetable protein (SOY), flavor, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, breadcrumbs, oregano, pepper, onion, red pepper, salt.",
            origin: "Import",
            nutrition: { energy: "1085.42 / 259.05 kJ/kcal", fat: "18.85g", saturated: "7.21g", carbs: "7.60g", sugar: "0g", protein: "14.75g", fiber: "0g", salt: "3.15g" },
            storage: "Store at temp. -18°C",
            notes: "Do not refreeze after thawing. Ideal for grilling or pan frying."
          },
          { 
            name: "Small Kofte", 
            ingredients: "Pork meat, vegetable protein (SOY), flavor, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, breadcrumbs, oregano, pepper, onion, red pepper, salt.",
            origin: "Import",
            nutrition: { energy: "1085.42 / 259.05 kJ/kcal", fat: "18.85g", saturated: "7.21g", carbs: "7.60g", sugar: "0g", protein: "14.75g", fiber: "0g", salt: "3.15g" },
            storage: "Store at temp. -18°C",
            notes: "Do not refreeze after thawing. Ideal for grilling or pan frying."
          },
          { 
            name: "Hamburger", 
            ingredients: "Pork meat, vegetable protein (SOY), flavors, monosodium glutamate E-621, stabilizer E-450, antioxidant E-301, preservative E-250, breadcrumbs, oregano, pepper, onion, red pepper, salt.",
            origin: "Import",
            nutrition: { energy: "1132.77 / 270.35 kJ/kcal", fat: "18.69g", saturated: "7.95g", carbs: "10.44g", sugar: "0g", protein: "15.69g", fiber: "1.19g", salt: "2.75g" },
            storage: "Store at temp. -18°C",
            notes: "Do not refreeze after thawing. Ideal for grilling or pan frying."
          },
          { 
            name: "Smoked Sausages", 
            ingredients: "Pork meat, Vegetable Protein (SOY), flavors, monosodium glutamate E-621, natural flavor (wood smoke), stabilizer E-450, antioxidant E-301, preservative E-250, pepper, salt.",
            origin: "Import",
            nutrition: { energy: "948.99 / 226.49 kJ/kcal", fat: "14.93g", saturated: "5.8g", carbs: "7.09g", sugar: "0g", protein: "15.94g", fiber: "0g", salt: "3.69g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing is edible.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/4azidk8b_021A2202.JPG"
          },
          { 
            name: "Special Sausages", 
            ingredients: "Pork meat, VEGETABLE PROTEIN (SOY), Flavor monosodium glutamate E-621, Stabilizer E-451, Antioxidant E-300, preservative E-202, Pepper, Salt.",
            origin: "Import",
            nutrition: { energy: "659.47 / 156.64 kJ/kcal", fat: "5g", saturated: "1.81g", carbs: "2.64g", sugar: "0.11g", protein: "25.27g", fiber: "0g", salt: "3.25g" },
            storage: "Store at temp. 1-5°C",
            notes: "Outer casing collagen material, edible.",
            image: "https://customer-assets.emergentagent.com/job_meat-chain-pro/artifacts/x2khrju9_021A2162.JPG"
          },
          { 
            name: "Smoked Meat", 
            ingredients: "Pork meat, Natural flavor (wood smoke), Salt, Preservative E-202.",
            origin: "Import",
            nutrition: { energy: "524.67 / 124.99 kJ/kcal", fat: "5.23g", saturated: "1.85g", carbs: "1.46g", sugar: "0g", protein: "18.02g", fiber: "0g", salt: "4.85g" },
            storage: "Store at temp. 1-5°C",
            notes: ""
          }
        ]
      },
      quality: {
        title: "Guaranteed Quality",
        points: [
          "100% fresh meat from our slaughterhouse",
          "Selected natural spices",
          "Traditional process combined with modern technology",
          "Quality control at every stage"
        ]
      },
      cta: "Request Deli Quote"
    },
    // About Page
    about: {
      title: "About Tamari",
      subtitle: "A complete chain. A responsibility shared at every step.",
      history: {
        title: "Origin",
        content: "Tamari was born from the conviction that meat is not merely a product — it is the result of a process that demands care, discipline and respect. From day one, we chose not to compromise on quality. We built a structure in which every link — from live livestock import, to the slaughterhouse, to packaging — answers to the same principle: work done properly."
      },
      philosophy: {
        title: "Our Philosophy",
        content: "We believe in the harmony between tradition and technology. Between the experience that comes with time and the precision that modern machinery offers. Every working hour at Tamari follows the same rhythm: control, clarity, responsibility. No noise, no shortcuts."
      },
      mission: {
        title: "Mission",
        content: "To be the trusted supplier of the meat industry in Albania — guaranteeing full traceability, European standards and a partnership that is built over time, not on promises. The B2B clients who choose us, choose us for simple reasons: consistency, seriousness, and the fact that every carcass, every cut, every package carries the same name — ours."
      },
      values: {
        title: "Our Values",
        items: [
          { title: "Quality", desc: "Without equivalent. Every product that leaves our line passes the same control as the first." },
          { title: "Reliability", desc: "Our relationships are measured in years, not in orders." },
          { title: "Transparency", desc: "Full traceability from livestock to the client's counter." },
          { title: "Innovation", desc: "Modern technology at the service of the process — not in place of it." }
        ]
      },
      numbers: {
        title: "Tamari in Numbers",
        items: [
          { number: "15+", label: "Years Experience" },
          { number: "500+", label: "B2B Partners" },
          { number: "100%", label: "Traceability" },
          { number: "24/7", label: "Support" }
        ]
      }
    },
    // Gallery Page
    gallery: {
      title: "Gallery",
      subtitle: "View our facilities and processes",
      categories: {
        all: "All",
        slaughterhouse: "Slaughterhouse",
        salami: "Deli Factory",
        stables: "Stables",
        transport: "Transport"
      },
      team: {
        title: "Our Team",
        subtitle: "Meet the professional team of Tamari"
      }
    },
    // Blog Page
    blog: {
      title: "News & Articles",
      subtitle: "Updates and information from Tamari",
      readMore: "Read more",
      categories: {
        all: "All",
        news: "News",
        industry: "Industry",
        tips: "Tips"
      },
      empty: "No articles at the moment."
    },
    // FAQ Page
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Answers to common questions from our B2B clients",
      categories: {
        all: "All",
        general: "General",
        ordering: "Ordering",
        delivery: "Delivery",
        quality: "Quality"
      },
      contact: "Didn't find your answer? Contact us directly."
    },
    // Contact Page
    contact: {
      title: "Contact Us",
      subtitle: "We are ready to discuss your specific needs",
      form: {
        name: "Full Name",
        company: "Company",
        businessType: "Business Type",
        businessTypes: {
          wholesale: "Wholesale",
          retail: "Retail / Store",
          distribution: "Distributor",
          restaurant: "Restaurant / HoReCa",
          other: "Other"
        },
        email: "Email",
        phone: "Phone",
        message: "Message",
        submit: "Send Request",
        success: "Message sent successfully!",
        error: "An error occurred. Please try again."
      },
      info: {
        email: "Email",
        phone: "Phone",
        slaughterhouse: "Slaughterhouse",
        slaughterhouseAddress: "Rruga Pularia, Dushnik, Berat, Albania",
        slaughterhouseHours: "Monday - Saturday: 07:00 - 16:00",
        salami: "Deli Factory",
        salamiAddress: "Rruga Mbroshkat Nr27, Lapardha, Berat, Albania",
        salamiHours: "Monday - Saturday: 07:00 - 15:00",
        hours: "Hours"
      }
    },
    // Quality Section
    quality: {
      title: "Quality & Safety",
      subtitle: "Full traceability from origin to final customer",
      features: {
        traceability: "100% Traceability",
        hygiene: "Supreme Hygiene",
        consistency: "Guaranteed Consistency",
        certification: "International Certifications"
      }
    },
    // Sustainability Section
    sustainability: {
      overline: "SUSTAINABILITY & STANDARDS",
      title: "Clean production. No compromise.",
      subtitle: "Every step of our chain respects the environment and the highest European standards.",
      features: [
        {
          title: "Waste Treatment",
          desc: "Modern incinerator for safe disposal of non-consumable waste."
        },
        {
          title: "Clean Waters",
          desc: "Dedicated plant for treatment of slaughterhouse wastewater."
        },
        {
          title: "Organic Recycling",
          desc: "Organic waste is converted into resources for local agriculture."
        },
        {
          title: "Animal Welfare",
          desc: "Raised in optimal conditions according to EU standards."
        }
      ],
      closing: "European standards. Local responsibility.",
      euOverline: "EU STANDARDS",
      euDesc: "Every aspect of our operations complies with European Union regulations and standards for food safety, environmental protection and animal welfare.",
      futureTitle: "Responsibility for the future",
      futureDesc: "We believe quality production and environmental responsibility go hand in hand. This is our way of doing business."
    },
    // Footer
    footer: {
      tagline: "Trusted supplier for the meat industry in Albania",
      rights: "All rights reserved",
      links: {
        services: "Services",
        about: "About Us",
        contact: "Contact",
        privacy: "Privacy"
      }
    },
    // Admin
    admin: {
      title: "Admin Panel",
      dashboard: "Dashboard",
      contacts: "Contacts",
      blog: "Blog",
      gallery: "Gallery",
      faq: "FAQ",
      products: "Products",
      stats: {
        totalContacts: "Total Contacts",
        newContacts: "New Contacts",
        blogPosts: "Blog Posts",
        galleryItems: "Gallery Items"
      },
      actions: {
        add: "Add",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        view: "View"
      },
      status: {
        new: "New",
        contacted: "Contacted",
        closed: "Closed"
      }
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      backToHome: "Back to Home",
      seeAll: "See all"
    }
  }
};
;
;
